import PropTypes from 'prop-types';
import React, { useState } from 'react';

// utils
import setState from '../../utils/setStateWithReturn';

const ErrorContext = React.createContext();

export function ErrorContextProvider({ children }) {
  const [error, setError] = useState(null);
  return (
    <ErrorContext.Provider
      value={{
        error,
        isError: !!error,
        setError: setState(setError),
      }}
    >
      {children}
    </ErrorContext.Provider>
  );
}

ErrorContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default ErrorContext;
